import { Injectable } from '@angular/core';
import { SharedDataService } from '../../data/services/shared-data.service';
import { BxLogger } from './bx-logger.service';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PendoFeedbackService {
    initialized = false;

    constructor(
        private router: Router,
        private sharedData: SharedDataService,
        private logger: BxLogger
    ) {}

    start() {
        this.router.events.subscribe((e) => {
            if (e instanceof NavigationEnd) {
                this.init()
                    .then(() => ({}))
                    .catch(() => ({}));
            }
        });
    }

    // @ts-ignore TS7006
    open = (elem) => {
        this.init().then(
            () => {
                window.receptivePublicLib.loginAndRedirect({ anchor: elem });
            },
            (err) => {
                this.logger.error(err);
            }
        );
    };

    init = () => {
        return new Promise((resolve, reject) => {
            if (!this.sharedData.UserData?.receptive) reject('Feature suggestion configuration not found');

            // Do not initialize for franchises if not available
            if (this.sharedData.UserData.franchise && !this.sharedData.UserData.franchise.IsFeatureSuggestAvailable)
                reject('Feature suggestion not available for this franchise');

            window.receptiveAppSettings = this.sharedData.UserData.receptive;
            window.receptiveAppSettings.return_url = window.location.origin;

            if (window.receptivePublicLib && this.initialized) {
                resolve(true);
            }

            const s = document.createElement('script');
            const r = false;
            s.type = 'text/javascript';
            s.src = 'https://receptive.io/js/widget/widget.js';
            s.async = true;
            s.onerror = function (err) {
                // @ts-ignore TS2339
                this.initialized = false;
                reject(err);
            };
            s.onload = () => resolve(true);
            const t = document.getElementsByTagName('script')[0];
            // @ts-ignore TS2532
            t.parentNode.insertBefore(s, t);
            this.initialized = true;
        });
    };
}
